import { Stack } from 'expo-router';

export default function AdminContactsTabLayout() {
  return <Stack screenOptions={{ headerShown: false }} />;
}
